export const ORDER_ON_BEHALF = 'order-on-behalf-banner';
